/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ p: NonNullable<unknown> }} Network_Demand_ValueInputs */



/**
* | output |
* | --- |
* | "- Network demand: {p}%" |
*
* @param {Network_Demand_ValueInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const network_demand_value = /** @type {((inputs: Network_Demand_ValueInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Network_Demand_ValueInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`- Network demand: ${i?.p}%`)
	return /** @type {LocalizedString} */ (`- Demande du réseau: ${i?.p}%`)
});